import TourCard from "./TourCard";

import { Swiper, SwiperSlide } from "swiper/react";

import SwiperCore, { Autoplay, Navigation } from "swiper";

export default function TourCarousel(props) {
  const { tours } = props;

  SwiperCore.use([Navigation, Autoplay]);

  return (
    <>
      <Swiper
        spaceBetween={50}
        slidesPerView={1}
        observer={true}
        observeParents={true}
        navigation={tours.length > 4}
        autoplay={{ delay: 5000, pauseOnMouseEnter: true }}
        breakpoints={{
          // when window width is >= 320px
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 2,
            spaceBetween: 30,
          },
          // when window width is >= 640px
          992: {
            slidesPerView: 3,
            spaceBetween: 40,
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 40,
          },
        }}
        key={Math.random() * 50}
      >
        {tours.map((tour) => (
          <SwiperSlide>
            <TourCard tour={tour} />
          </SwiperSlide>
        ))}
      </Swiper>
    </>
  );
}
